import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'; // Import Provider for Redux
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import dcmmApi, { auth } from './utils/httpClient';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

(async () => {
  await auth.bootstrapAuth([dcmmApi]); // mints AT from RT cookie
  root.render(
    <React.StrictMode>
      <Provider store={store}> {/* Wrap Redux Provider */}
        <BrowserRouter> {/* Wrap App in BrowserRouter */}
          <App />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );
})();
reportWebVitals();
